import { apiFuns } from "sw-hic";
let { get, post, del, genStandard } = apiFuns;
let api = {
  Role: {
    ...genStandard("role", "/api/md"),
    queryStaff: (roleCode, para) => get(`/api/md/role/${roleCode}/staff`, para),
  },

  Apply: {
    ...genStandard("apply", "/api/md"),
  },

  Staff: {
    ...genStandard("staff", "/api/md"),
    addRole: (id, roleCode) => post(`/api/md/staff/${id}/role/${roleCode}`),
    delRole: (id, roleCode) => del(`/api/md/staff/${id}/role/${roleCode}`),
  },

  TenantApply: {
    ...genStandard("tenantApply", "/api/md"),
  },
};
export default api;
